export default __webpack_public_path__ + "41d551a094475420326e560a106428a9.png";